/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef } from 'react'
import isEqual from 'lodash/isEqual'

function useDeepCompareMemoize(value?: any) {
  const ref = useRef()

  if (!value) return undefined

  if (!isEqual(value, ref.current)) {
    ref.current = value
  }

  return ref.current
}

const useDeepEffect: typeof useEffect = (
  effect: React.EffectCallback,
  deps?: ReadonlyArray<any>
) => {
  useEffect(effect, useDeepCompareMemoize(deps))
}

export default useDeepEffect
